import { fromJS } from 'immutable';
import React, { useEffect, useState } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import { getTicketIconClass, scoreSeparator } from '@/mytickets/utils';
import betStatus from '@/mytickets/constants/betStatus';
import i18n from '@i18n';
import { formatDateOverview, formatMoney } from '@/common/client';
import { fetchTicket } from '@/mytickets/detail/api';
import { fetchSavedTicketByNumber } from '@/mytickets/saved/api';
import { TICKET_DETAIL } from '@/routing/routes';
import { navigate } from '@/routing';
import { ticketDetailBets } from '@/mytickets/detail/subs';

export function TicketModule({ ticketHash, ticketVisualNr }) {
    const derefSub = useReframe();
    const [hash, setHash] = useState(ticketHash);

    useEffect(
        function subscribeTicket() {
            if (ticketHash) {
                fetchTicket(ticketHash);
            }
            if (ticketVisualNr) {
                fetchSavedTicketByNumber(ticketVisualNr)
                    .then(json => {
                        dispatch(['ticketus/detail/fetched', fromJS(json)]);
                        setHash(json.hash);
                    })
                    .catch(error => console.error('error fetchSaveTicket', ticketVisualNr, error));
            }
        },
        [ticketHash, ticketVisualNr]
    );

    function goToDetail(e) {
        e.preventDefault();
        navigate(TICKET_DETAIL, { hash: ticket.get('hash') });
    }

    const ticket = derefSub(['ticketus/detailOrOverview/ticket', hash]);
    const bets = derefSub(ticketDetailBets(hash));

    if (!ticket || ticket.get('error')) {
        return null;
    }
    return (
        <div className="ticket-module" onClick={e => goToDetail(e)}>
            {bets && <Bets bets={bets} />}
            {ticket && <TicketDetail ticket={ticket.toJS()} />}
        </div>
    );
}

function Bets({ bets }) {
    return (
        <div className="bets">
            {bets.slice(0, 4).map(bet => (
                <Bet key={bet.get('betId')} bet={bet} />
            ))}
            {bets.size > 4 ? <div className="icon-more" /> : null}
            <BetsStats bets={bets} />
        </div>
    );
}

function BetsStats({ bets }) {
    const wonCount = bets.filter(b => b.get('status') === betStatus.Won).size;
    const lostCount = bets.filter(b => b.get('status') === betStatus.Lost).size;
    const registeredCount = bets.filter(b => b.get('status') === betStatus.Registered).size;

    return (
        <div className="bets-stats">
            {registeredCount ? <div className="status-badge Registered">{registeredCount}</div> : null}
            {wonCount ? <div className="status-badge Won">{wonCount}</div> : null}
            {lostCount ? <div className="status-badge Lost">{lostCount}</div> : null}
        </div>
    );
}

const Bet = ({ bet }) => (
    <div className="bet">
        {bet.getIn(['opponents', 0])}
        <span className="opponent-separator">{scoreSeparator(bet)}</span>
        {bet.getIn(['opponents', 1])}
    </div>
);

function TicketDetail({ ticket }) {
    const statusIcon = getTicketIconClass(ticket);
    const mena = 'EUR';

    return (
        <div className="ticket-strip">
            <div className={'status-strip ' + ticket.displayStatus} />
            <div className="left-section">
                <div className={statusIcon} />
            </div>
            <div className="mid-section">
                <div className="ticket-win">
                    <b>{formatMoney(ticket.win, mena)}</b>
                </div>
                <div className="ticket-date">{formatDateOverview(ticket.submitDate)}</div>
            </div>
            <div>
                <div className="ticket-stake">
                    {i18n('jsp.tiket.vklad')} <b>{formatMoney(ticket.stake, mena)}</b>
                </div>
                <div className="ticket-odds">
                    {i18n('jsp.detailTiketu.kurz')} <b>{formatMoney(ticket.odds, mena)}</b>
                </div>
            </div>
        </div>
    );
}
